import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import PHLogo from "@/Images/Logos/PHLogo_White.png";

const Loading = ({ children }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [minimumTimeElapsed, setMinimumTimeElapsed] = useState(false);

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      setShowLoading(true);
    }, 200);

    const minimumDisplayTimer = setTimeout(() => {
      setMinimumTimeElapsed(true);
    }, 2000);

    return () => {
      clearTimeout(delayTimer);
      clearTimeout(minimumDisplayTimer);
    };
  }, []);

  if (showLoading && !minimumTimeElapsed) {
    return (
      <div className="bg-[#002169] h-screen w-screen flex flex-col justify-center items-center">
        <img src={PHLogo} alt="Loading Logo" className="w-[450px] mb-12" />
        <CircularProgress size={80} thickness={4.5} sx={{ color: "#ffffff" }} />
        <p className="text-white text-lg mt-5">Loading, please wait...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default Loading;
